import { PromoAnalyticsService } from '@analytics/feature';
import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { BannersWithButtonItem, BannerWithButtonItem } from '@promo/const';
import { PromoService } from '@promo/data-access';
import { InViewportDirective } from '@sdvor/shared/ui';
import { DeviceService } from '@shared/services';
import { combineLatest, filter, map, Observable } from 'rxjs';
import { BannerWithButtonItemComponent } from './banner-with-button-item';

@Component({
  selector: 'sd-banners-with-button',
  imports: [AsyncPipe, BannerWithButtonItemComponent, InViewportDirective],
  templateUrl: './banners-with-button.component.html',
  styleUrls: ['./banners-with-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BannersWithButtonComponent implements OnInit {
  isTablet$: Observable<boolean> = this.deviceService.isTabletMdUp$;
  isDesktop$: Observable<boolean> = this.deviceService.isDesktopLgUp$;
  isLoading$: Observable<boolean> = this.promoService.getPromoLoading();

  bannersWithButton$: Observable<BannersWithButtonItem>;

  constructor(
    public deviceService: DeviceService,
    private promoService: PromoService,
    private promoAnalyticsService: PromoAnalyticsService,
  ) {}

  ngOnInit(): void {
    this.bannersWithButton$ = combineLatest({
      promo: this.promoService.getPromo().pipe(filter((promo) => !!promo)),
      isTablet: this.isTablet$,
      isDesktop: this.isDesktop$,
    }).pipe(
      map(({ promo, isTablet, isDesktop }) => {
        if (promo.bannersWithButton) {
          const { label, banners } = promo.bannersWithButton;

          return {
            label,
            banners: banners.map((banner) => ({
              ...banner,
              url: isDesktop ? banner.url.isDesktop : isTablet ? banner.url.isTablet : banner.url.isMobile,
            })),
          };
        }

        return {} as BannersWithButtonItem;
      }),
    );
  }

  protected onBannerIntersect(banner: BannerWithButtonItem): void {
    const { id, name } = banner;

    this.promoAnalyticsService.onShowBanner({
      id,
      name,
      position: 'main_page',
    });
  }
}
